import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MilestoneData } from '../../../services/milestones/MilestoneData';
import { MilestoneUtil } from '../../../MilestoneUtil';
import { categoryToIcon, categoryToLabel } from '../../../model/milestones/MilestoneCategory';
import { DateUtil } from '../../../DateUtil';
import { ValidatorUtil } from 'src/app/shared/ValidatorUtil';

@Component({
  selector: 'digires-milestone-entry',
  templateUrl: './milestone-entry.component.html',
  styleUrls: ['./milestone-entry.component.scss'],
})
export class MilestoneEntryComponent implements OnChanges {
  readonly DATE_INPUT_ERRORS = ValidatorUtil.DATE_INPUT_ERRORS;
  readonly ValidatorUtil = ValidatorUtil;

  @Output() onDateClicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Input() data: MilestoneData;
  @Input() readOnly: boolean;
  @Input() readOnlyReason: string;
  @Input() projectCreation: boolean;

  categoryLabel: string;
  categoryIcon: string;
  cachedSummary: string;
  incomingDependenciesRefs: string;
  outgoingDependenciesRefs: string;
  placeholder: string;

  ngOnChanges() {
    const category = this.data.ms.category;
    this.categoryLabel = categoryToLabel[category];
    this.categoryIcon = categoryToIcon[category];

    if (this.data.ms.summary && this.data.ms.summary.length > 0) {
      this.cachedSummary = this.data.ms.summary;
    } else if (this.data.ms.synthetic && !this.data.ms.hasIncomingDependencies) {
      this.cachedSummary = 'The end of stage is determined by the latest key milestone within the stage.';
    } else {
      this.cachedSummary = 'Summary to be added';
    }

    this.incomingDependenciesRefs = this.data.ms.incomingDependencies
      .map((depMs) => depMs.source.customRef)
      .join(' && ');
    this.outgoingDependenciesRefs = this.data.ms.outgoingDependencies.map((depMs) => depMs.customRef).join(' && ');

    this.placeholder = this.data.ms.synthetic
      ? 'Auto-Calculated Date'
      : this.data.mandatory
        ? 'Mandatory Milestone'
        : 'Optional Milestone';
  }

  isDateInPast(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isIncompleteInPast({
      date: DateUtil.anyToDate(fgValue.date),
      done: fgValue.complete,
      na: fgValue.notApplicable,
    });
  }

  isDateInFuture(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isCompleteInFuture({
      date: DateUtil.anyToDate(fgValue.date),
      done: fgValue.complete,
      na: fgValue.notApplicable,
    });
  }

  onDateInputClicked(event: MouseEvent) {
    if (!this.readOnly && !this.data.ms.synthetic && !this.data.ms.hasIncomingDependencies) {
      this.onDateClicked.emit(event);
    }
  }
}
